import React from 'react';
import './TrainingProgram.css';
import PageHeader from '../about/PageHeader';
import Navbar from '../components/navbar';
import Footer from "../components/Footer";

// SVG Icons as unique components to keep JSX clean
const IconBulb = () => (
  <svg className="tp-card-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
  </svg>
);

const IconBriefcase = () => (
  <svg className="tp-card-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="7" width="20" height="14" rx="2" ry="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/>
  </svg>
);

const TrainingProgram = () => {
  return (
     <>
      <Navbar />

      {/* Hero Section */}
     <PageHeader
                  title="Training Programme"
                  crumbs={[{ label: "Home", href: "/" }, { label: "Training Programme" }]}
                />

      <div className="tp-content-layout">
        {/* Left Column: Content */}
        <main className="tp-primary-content">
          <header className="tp-content-header">
                       
            <p className="tp-intro-text">
              At TIMSCDR, training programmes are conducted for the students from the 1st semester itself 
              to make them employable and assist them in their preparation for transition from campus to corporate.
            </p>
            <p className="tp-sub-intro">
              The Institute undertakes following programmes besides the MCA curriculum:
            </p>
          </header>

    <div className="tp-program-cards-stack">
  {/* Card 1: Student Development */}
  <article className="tp-program-feature-card">
    <div className="tp-card-visual">
      <IconBulb />
    </div>
    <div className="tp-card-details">
      <h3 className="tp-card-title">Student Development Program</h3>
      <p className="tp-card-description">
        A comprehensive training programme is implemented through a series of workshops, guest lectures, 
        seminars and simulation exercises for students to become ready for the ever changing corporate landscape. 
        TIMSCDR organizes an International conference every year to provide a platform for the students, 
        researchers and faculty to get acquainted with the current trends and practices. 
        Extracurricular and extension activities, student managed clubs and events give them further 
        avenues to express themselves and develop skills beyond academics. 
        The Institute also has a very active entrepreneurship cell.
      </p>
    </div>
  </article>

  {/* Card 2: Pre-Placement */}
  <article className="tp-program-feature-card">
    <div className="tp-card-visual">
      <IconBriefcase />
    </div>
    <div className="tp-card-details">
      <h3 className="tp-card-title">Pre-Placement Training</h3>
      <p className="tp-card-description">
        The Institute organizes a pre-placement training focused on corporate ethics and etiquettes 
        and other soft skills to give students an exposure to industry work culture, ethics and etiquettes 
        followed in the corporate sector. They are also provided training in aptitude skills, resume writing 
        and interview skills. Mock aptitude test, group discussion and personal interviews are conducted 
        to evaluate preparedness of the students.
      </p>
    </div>
  </article>
</div>
        </main>

        {/* Right Column: Widgets */}

      </div>
<Footer />
    </>
  );
};

export default TrainingProgram;